import { Lock } from 'lucide-react';
import { Text } from '@/components/ui/Text';

export interface NotAuthorizedProps {
  /** What the user tried to reach, e.g. "Clients" — used in the message. */
  resourceLabel?: string;
}

/**
 * Inline 403-style page rendered when the caller lacks the UI permission-key for
 * a route. UX-only — the BE independently authorizes every real call; this is
 * just a friendlier landing than a blank screen for a disallowed deep-link.
 */
export function NotAuthorized({ resourceLabel }: NotAuthorizedProps) {
  const what = resourceLabel ? `the ${resourceLabel} section` : 'this section';
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="w-12 h-12 rounded-full bg-surface-muted flex items-center justify-center mb-3">
        <Lock size={22} className="text-text-subtle" />
      </div>
      <Text variant="headline-sm" as="h1" className="tracking-tight">No access</Text>
      <Text variant="body-md" color="muted" className="mt-1 max-w-md">
        You don't have permission to view {what} in the active context. Switch context or ask an
        administrator if you think this is a mistake.
      </Text>
    </div>
  );
}
